/**
 * The Bridge- Wellness & Therapy Center — site-wide config.
 * Prefer these env names; legacy REACT_APP_LISA_* / REACT_APP_I3_* still work as fallbacks.
 */

const trim = (v: string | undefined) => (v ?? '').trim();

/** P5 / EngageOS portal site key when using SQL-backed CMS */
export const BRIDGE_PORTAL_SLUG =
  trim(process.env.REACT_APP_BRIDGE_PORTAL_SLUG) ||
  trim(process.env.REACT_APP_LISA_PORTAL_SLUG) ||
  'the-bridge';

/** Static CMS JSON (default: public/cms/lisa/site-content.json) */
export const BRIDGE_CMS_STATIC_URL =
  trim(process.env.REACT_APP_BRIDGE_CMS_URL) ||
  trim(process.env.REACT_APP_LISA_CMS_URL) ||
  trim(process.env.REACT_APP_I3_CMS_URL) ||
  '/cms/lisa/site-content.json';

/** Formspree contact form */
export const BRIDGE_FORMSPREE_URL =
  trim(process.env.REACT_APP_BRIDGE_FORMSPREE_URL) ||
  trim(process.env.REACT_APP_LISA_FORMSPREE_URL) ||
  'https://formspree.io/f/xpqeeobj';

/** Set to `true` to fetch CMS JSON / portal API at runtime */
export const BRIDGE_ENABLE_CMS_FETCH =
  process.env.REACT_APP_BRIDGE_ENABLE_CMS_FETCH === 'true' ||
  process.env.REACT_APP_LISA_ENABLE_CMS_FETCH === 'true';

/** Hide “Content: live (P5 CMS)” badge in footer */
export const BRIDGE_HIDE_CMS_BADGE =
  process.env.REACT_APP_HIDE_BRIDGE_CMS_BADGE === 'true' ||
  process.env.REACT_APP_HIDE_I3_CMS_BADGE === 'true';

/** Optional hero video override */
export const BRIDGE_HERO_VIDEO_URL = trim(process.env.REACT_APP_BRIDGE_HERO_VIDEO_URL) ||
  trim(process.env.REACT_APP_HERO_VIDEO_URL);
